var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// some imports must use wildcard for it to work with rollupjs
import * as _privToAddress from 'ethereum-private-key-to-address';
import * as ethers from 'ethers';
import anyToHex from 'to-hex';
import * as uuidlib from 'uuidv4';
import qs from 'querystring';
const { uuid } = uuidlib;
export const uuidv4 = uuid;
export const privateKeyToAddress = _privToAddress;
export const wait = (t) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise(resolve => setTimeout(() => resolve(), t));
});
export const toHex = (value, opts = {}) => {
    if (opts.addPrefix === undefined) {
        opts.addPrefix = true;
    }
    opts.default = 0;
    return anyToHex(value, opts);
};
export const signWithPrivateKey = (message, privateKey, providerUri) => __awaiter(void 0, void 0, void 0, function* () {
    if (!privateKey) {
        throw new Error('private key is required');
    }
    const provider = new ethers.providers.JsonRpcProvider(providerUri);
    const wallet = new ethers.Wallet(privateKey, provider);
    let data = message;
    if (message.startsWith('0x')) {
        data = ethers.utils.arrayify(message);
    }
    const signature = yield wallet.signMessage(data);
    const address = privateKeyToAddress(privateKey);
    /*
    const verified = verifySignature(message, signature, address)
  
    if (!verified) {
      throw new Error('signature produced is invalid')
    }
     */
    return signature;
});
export const debounce = (callback, time) => {
    let interval;
    return (...args) => {
        clearTimeout(interval);
        interval = setTimeout(() => {
            interval = null;
            callback(...args);
        }, time);
    };
};
export const throttle = (fn, interval, limit = 1) => {
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    const throttled = function (...args) {
        let timeout;
        return new Promise((resolve, reject) => {
            const execute = () => {
                resolve(fn.apply(this, args));
                queue.delete(timeout);
            };
            const now = Date.now();
            if ((now - currentTick) > interval) {
                activeCount = 1;
                currentTick = now;
                timeout = setTimeout(execute, currentTick - now);
            }
            else if (activeCount < limit) {
                activeCount++;
            }
            else {
                activeCount = 1;
            }
            queue.set(timeout, reject);
        });
    };
    return throttled;
};
export const getQueryParamValue = (name) => {
    const query = window.location.search.substr(1);
    const params = qs.parse(query);
    if (params[name]) {
        return params[name];
    }
    return null;
};
export const removeQueryParam = (key, url = window.location.href) => {
    try {
        const u = new URL(url);
        if ('URLSearchParams' in window) {
            const searchParams = new URLSearchParams(u.search);
            searchParams.delete(key);
            u.search = searchParams.toString();
            return u.toString();
        }
    }
    catch (err) {
        // noop
    }
    return url;
};
export const updateQueryParams = (params = {}, url = window.location.href) => {
    try {
        const u = new URL(url);
        if ('URLSearchParams' in window) {
            const searchParams = new URLSearchParams(u.search);
            for (let key in params) {
                searchParams.set(key, params[key]);
            }
            u.search = searchParams.toString();
            return u.toString();
        }
    }
    catch (err) {
        // noop
    }
    return url;
};
export const replaceWindowUrl = (newUrl) => {
    try {
        window.history.replaceState({}, document.title, newUrl);
    }
    catch (err) {
        // noop
    }
};
export const browserInfo = () => {
    let ret;
    let tmp;
    let ua = navigator.userAgent;
    let m = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(m[1])) {
        tmp = /\brv[ :]+(\d+)/g.exec(ua) || [];
        ret = 'IE ' + (tmp[1] || '');
    }
    if (m[1] === 'Chrome') {
        tmp = ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if (tmp != null) {
            ret = tmp.slice(1).join(' ').replace('OPR', 'Opera').replace('Edg ', 'Edge ');
        }
    }
    m = m[2] ? [m[1], m[2]] : [navigator.appName, navigator.appVersion, '-?'];
    let v = (tmp = ua.match(/version\/(\d+)/i)) != null;
    if (v) {
        m.splice(1, 1, tmp[1]);
    }
    ret = m.join(' ');
    let p = ret.split(' ');
    return {
        browser: p[0],
        version: p[1]
    };
};
